import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const NOTIFICATION_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const AUTOREPLY_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_AUTOREPLY_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const OWNER_NAME = 'Sahas Belbase';
const OWNER_EMAIL = 'belbase.sahas@gmail.com';

/**
 * Sends notification email to Sahas and automated thank-you to the visitor.
 *
 * The two emails travel in opposite directions, so they cannot share one set of
 * params. Each template gets its own recipient and its own Reply-To:
 *
 *   Notification  -> Sahas    To: {{to_email}} = Sahas   Reply-To: {{reply_to}} = visitor
 *   Auto-reply    -> visitor  To: {{to_email}} = visitor Reply-To: {{reply_to}} = Sahas
 *
 * Map those variables in the EmailJS dashboard to match. Pointing an auto-reply's
 * Reply-To back at its own recipient is both useless and a spam signal.
 *
 * @param {{ name: string, email: string, message: string }} contactData
 */
export const sendContactEmails = async ({ name, email, message }) => {
  if (!PUBLIC_KEY) {
    console.warn('EmailJS Public Key is not configured yet in .env');
    return { success: false, error: 'EmailJS Public Key missing' };
  }

  // Details of the enquiry itself, identical in both emails.
  const enquiry = {
    name,
    from_name: name,
    user_name: name,
    email,
    from_email: email,
    user_email: email,
    message,
    user_message: message,
    date: new Date().toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }),
    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
  };

  // Lands in Sahas's inbox; replying should reach the visitor.
  const notificationParams = {
    ...enquiry,
    to_name: OWNER_NAME,
    to_email: OWNER_EMAIL,
    reply_to: email,
  };

  // Lands in the visitor's inbox; replying should reach Sahas.
  const autoReplyParams = {
    ...enquiry,
    to_name: name,
    to_email: email,
    from_name: OWNER_NAME,
    from_email: OWNER_EMAIL,
    reply_to: OWNER_EMAIL,
  };

  const tasks = [];

  // 1. Send notification to Sahas
  if (NOTIFICATION_TEMPLATE_ID) {
    tasks.push(
      emailjs.send(SERVICE_ID, NOTIFICATION_TEMPLATE_ID, notificationParams, PUBLIC_KEY)
    );
  }

  // 2. Send auto-reply to visitor
  if (AUTOREPLY_TEMPLATE_ID && AUTOREPLY_TEMPLATE_ID !== NOTIFICATION_TEMPLATE_ID) {
    tasks.push(
      emailjs.send(SERVICE_ID, AUTOREPLY_TEMPLATE_ID, autoReplyParams, PUBLIC_KEY)
    );
  }

  return Promise.allSettled(tasks);
};
